import script from "./TrainerAcademy.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerAcademy.vue?vue&type=script&setup=true&lang=js"

import "./TrainerAcademy.vue?vue&type=style&index=0&id=5e31c252&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e31c252"]])

export default __exports__